import { Language as LanguageSchema } from "@monkeytype/schemas/languages";
import { Optgroup } from "slim-select/store";
import { JSXElement } from "solid-js";

import { configMetadata } from "../../../../config/metadata";
import { setConfig } from "../../../../config/setters";
import { getConfig } from "../../../../config/store";
import {
  LanguageGroupNames,
  LanguageGroups,
} from "../../../../constants/languages";
import { getLanguageDisplayString } from "../../../../utils/strings";
import SlimSelect from "../../../ui/SlimSelect";
import { SearchableSetting } from "../SearchableSetting";

// built once - a new array on every read would make SlimSelect rebuild its options
const languageOptionGroups = LanguageGroupNames.map(
  (group) =>
    ({
      label: group,
      options: LanguageGroups[group]?.map((language) => ({
        text: getLanguageDisplayString(language),
        value: language,
      })),
    }) as Optgroup,
);

export function Language(): JSXElement {
  return (
    <SearchableSetting
      key="language"
      title="language"
      description={configMetadata.language.description}
      fa={configMetadata.language.fa}
      inputs={
        <SlimSelect
          optionGroups={languageOptionGroups}
          selected={getConfig.language}
          onChange={(val) => {
            if (getConfig.language === (val as LanguageSchema)) return;
            setConfig("language", val as LanguageSchema);
          }}
        />
      }
    />
  );
}
